import { createStore } from 'satcheljs';
import { getAppStore } from '../../../../@data';
import { IReportViewState } from './schema/IReportViewState';

export enum RouteName {
  dashboard = 'dashboard',
  reportDetails = 'report-details',
  overview = 'overview',
  landing = 'landing',
  details = 'details',
}

export const defaultRoute = RouteName.dashboard;
export const SESSION_STORAGE_REPORT_ID_KEY = 'reportIdKey';
export const LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY = 'showReportUnsavedDialog';

export const getPageStore = createStore<IReportViewState>('ReportViewState', {
  loading: false,
  reports: [],
});

export const getPublisherId = (): string => {
  const match = window.location.pathname.match(/\/(\d+)\//);
  return match ? match[1] : getAppStore().publisher?.id;
};
